import React, { useCallback } from 'react';
import { useHistory }         from 'react-router-dom';
import * as PropTypes         from 'prop-types';

import renderStaticSection from '../../../templates/_common/utils/renderStaticSection';

const SearchInfoItem = function(props) {
  const {
          description,
          handleSearchClose,
          label,
          urlKey,
        } = props;

  const history = useHistory();

  let content = {};

  const handleContainerClick = useCallback((event) => {
    event.stopPropagation();

    if (!event.target.closest('a')) {
      history.push(urlKey);
      handleSearchClose();
    }
  }, [handleSearchClose, history]);

  try {
    content = JSON.parse(description);
  } catch (e) {
    return null;
  }

  return (
    <div
      onClick={handleContainerClick}
      className={'item new inline'}
    >
      <div className={'questions_wrapper'}>
        <div className={'title'}>
          {label}
        </div>
        <div className={'description'}>
          {content.SECTIONS.map((section, index) => renderStaticSection(section, index))}
        </div>
      </div>
    </div>
  );
};

SearchInfoItem.propTypes = {
  description:       PropTypes.string.isRequired,
  handleSearchClose: PropTypes.func,
  label:             PropTypes.string.isRequired,
  urlKey:            PropTypes.string.isRequired,
};

export default SearchInfoItem;